import { CollectionCardRarity } from 'src/services/apollo/generated/graphql'
import type {
  CollectionCard,
  CollectionCardSetProgress,
} from 'src/services/apollo/generated/graphql'

export function getCoverCollectionCard(ownedCollectionCards: CollectionCard[]) {
  const sorted = getSortedTotalCollectionCards(ownedCollectionCards)
  return sorted.find(
    card =>
      card.rarity === CollectionCardRarity.Ssr ||
      card.rarity === CollectionCardRarity.Sr ||
      card.rarity === CollectionCardRarity.N,
  )
}

export function getCollectionCardProgressString(
  progress: CollectionCardSetProgress,
) {
  const { ownedCollectionCards, totalCollectionCards } = progress
  const progressString = `${ownedCollectionCards.length} / ${totalCollectionCards.length}`
  return progressString
}

export function getSortedTotalCollectionCards(
  collectionCards: CollectionCard[],
) {
  const cards = Array.from(collectionCards)
  return cards.sort(
    // Ensure cards with no collectionCardSetOrder are at the end
    (a, b) =>
      (a.collectionCardSetOrder ?? 999) - (b.collectionCardSetOrder ?? 999),
  )
}
